import { useEffect, useState } from "react";
import { RxHamburgerMenu } from "react-icons/rx";

import { LiaShoppingBagSolid } from "react-icons/lia";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import colors from "../../../theme/color/ColorTheme";
import LogoDefaultText from "../../logo/LogoDefaultText";
import LogoFull from "../../logo/LogoFull";
import SidemenuCart from "../../section/cart/SidemenuCart";
import SidemenuCartEdit from "../../section/cart/SidemenuCartEdit";
import SearchOverlay from "../../section/search/SearchOverlay";
import MobileNavDrawer from "./drawer/MobileNavDrawer";

/* ===================== STYLES ===================== */

const Wrapper = styled.div``;

const Container = styled.div`
  height: 100px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 40px;
  background: ${({ $scrolled, $isMenuOpen }) =>
    $scrolled || $isMenuOpen ? "#fff" : "transparent"};
  border-bottom: ${({ $scrolled }) =>
    $scrolled ? `1px solid ${colors.line}` : "transparent"};
  transition: all 0.4s ease;
`;

const NavIcon = styled.div`
  cursor: pointer;

  svg {
    height: 24px;
    width: 24px;
    color: ${colors.blackMuted};
  }
`;

const Right = styled.div`
  display: flex;
  gap: 24px;
  justify-self: end;
`;

/* ===================== COMPONENT ===================== */

function MobileNavbar() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Wrapper>
      {drawerOpen && <MobileNavDrawer onClose={() => setDrawerOpen(false)} />}

      <Container $scrolled={scrolled} $isMenuOpen={openMenu}>
        <NavIcon onClick={() => setDrawerOpen(true)}>
          <RxHamburgerMenu />
        </NavIcon>

        {scrolled ? <LogoFull /> : <LogoDefaultText />}

        <Right>
          {/* <NavIcon onClick={() => setOpenMenu("search")}>
            <LuSearch />
          </NavIcon> */}
          <NavIcon onClick={() => setOpenMenu("cart")}>
            <LiaShoppingBagSolid />
          </NavIcon>
        </Right>
      </Container>

      {openMenu === "search" && (
        <SearchOverlay onClose={() => setOpenMenu(null)} />
      )}

      {openMenu === "cart" && (
        <SidemenuCart
          onClose={() => setOpenMenu(null)}
          onOpenEdit={() => setOpenMenu("cartEdit")}
        />
      )}

      {openMenu === "cartEdit" && (
        <SidemenuCartEdit onClose={() => setOpenMenu("cart")} />
      )}
    </Wrapper>
  );
}

export default MobileNavbar;
